import React from 'react';
import variables from '../../styles/variables.module.scss';
import Highlight from '../../components/Highlight';

import extraimg1 from '../../assets/frames/installationspartner-extraimg1@2x-min.png';
import extraimg2 from '../../assets/frames/installationspartner-extraimg2@2x-min.png';
import extraimg3 from '../../assets/frames/installationspartner-extraimg3@2x-min.png';
import hero from '../../assets/hero/insallationspartner-hero@2x-min.png';
import env1 from '../../assets/envImages/installationspartner-env1-min.jpg';
import env2 from '../../assets/envImages/installationspartner-env2-min.jpg';
import footerBanner from '../../assets/envImages/installationspartner-footerBanner-min.jpg';


export default {
  path: '/cases/installationspartner',
  color: variables.installationspartner,
  hero: { fall: hero },
  xtra: [
    { fall: extraimg1 },
    { fall: extraimg2 },
    { fall: extraimg3 },
  ],
  footerBanner: { fall: footerBanner },
  environments: { env1, env2 },
  quoteData: {
    quote: 'We App helped us automate and digitalize a huge number of manual processes. We loved that they took the time to fully grasp the full picture before getting to work. Which ensured a swift and accurate delivery. We\'d love to work on future projects together.',
    name: 'Carl Palsson',
    profession: 'CEO, Installationspartner AB',
  },
  title: 'Installationspartner',
  sideHeadingFirst: 'iOS & Android application',
  sideHeadingSecond: 'Developed in React Native',
  infoTitle: 'What we built',
  infoBody:
  <span>
    We App helped Installationspartner digitalize the whole process. A powerful app was built, through which consumers can request a range of construction and household services. These services can then be accepted by any of the handy-men professionals in the network that lives up to the requirement criteria.
    <br />
    <br />
    Information is updated and passed automatically between all partners, which keeps the process transparent and smooth running. Waiting times for consumers has been significantly cut, and so has the maintenance time of Installationspartner’s personnel.
    <br />
    <br />
    {'The mobile app was built in '}
    <Highlight>React Native</Highlight>
    {'. With notifications handled by '}
    <Highlight>Firebase</Highlight>
.
  </span>,
  infoData: {
    Scope: ['Scope', 'Project management', 'User experience', 'UI & UX design'],
    Deliverables: ['Deliverables', 'iOS development', 'Android development', 'Cross-platform', 'Software development'],
    Goal: ['Goal', 'Project management', 'User experience', 'UI & UX design', 'Maintanance/support'],
  },
  titleBodyData: {
    0: {
      title: 'A true digitalization journey',
      body: 'In a time when the word “digitalization” is thrown around quite frivolously, Installationspartner can proudly say they did not only digitalize their processes, they kicked it out of the park and took it to the next level. Going from a completely manual process to a completely digital one.',
    },
    1: {
      title: 'Automation with great service',
      body:
  <span>
Installationspartner is a Swedish organization that connect house and facility owners to handy-men and women, by handling the orders of construction and household maintenance services. Installationspartner vets professionals, and connects customers jobs to the professionals that lives up to their high criteria of craftsmanship.
    <br />
    <br />
As such, they need to both receive, and then distribute all the amount of work and information in projects, and keep track of all material specifications, changes to schedule, and unforeseen events that occur. And before
    {' '}
    <Highlight>We App</Highlight>
    {' '}
teamed up with them, this was an entirely manual process, put on a physical map with needles, strings and notes.
  </span>,
    },
  },
};
